import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "./Reveal";
import { IMAGES } from "../content";

const LabBreak = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-9%", "9%"]);

  return (
    <section data-testid="lab-break" className="relative py-10 md:py-16">
      <div className="mx-auto max-w-[calc(100%-2rem)] md:max-w-[calc(100%-4rem)]">
        <Reveal>
          <div ref={ref} className="relative h-[70vh] min-h-[440px] rounded-[2.5rem] overflow-hidden">
            <motion.img
              data-testid="lab-break-img"
              src={IMAGES.lab}
              alt="The LendRobot underwriting lab"
              style={{ y, scale: 1.18 }}
              className="absolute inset-0 w-full h-full object-cover"
              draggable="false"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B33]/85 via-[#0B1B33]/20 to-transparent" aria-hidden="true" />
            <div className="absolute inset-x-0 bottom-0 p-8 md:p-14">
              <p className="label-mono text-[#7FE9FF] mb-4">The LendRobot underwriting lab</p>
              <h2 className="font-display font-bold tracking-[-0.02em] leading-[1.02] text-white text-4xl md:text-6xl max-w-2xl">
                Built in a lab.<br />Approved by humans.
              </h2>
              <p className="mt-5 max-w-md text-sm md:text-base leading-relaxed text-white/70">
                Our engines read thousands of applications a day — and when something looks
                unusual, it lands on a human underwriter's desk within one business day.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default LabBreak;
